module.exports = __webpack_public_path__ + "static/media/sq-stuff-envelope-poster.864b3846.png";